/*
 * Public API Surface of pepperi-lib/size-detector
 */
export * from './size-detector.module';
export * from './size-detector.component';
